module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue-loader/lib/template-compiler.js?{"id":"data-v-2a9581c6"}!F:/Solutions/6682bo/master/~/vue-loader/lib/selector.js?type=template&index=0!F:/Solutions/6682bo/master/~/vue2-google-maps/dist/components/placeInput.vue
// module id = 256
// module chunks = 1